import OtpInput from 'react-otp-input';
import './fpComp.scss';
import React, {useEffect, useState} from 'react';
import {Http} from '../../../../helpers/axois';
import {useHistory} from 'react-router';
import {useToast} from '../../../../helpers/commonFunction';

function OtpVerification() {

    const [ otp, setOtp ] = useState('');
    const [ timerCompleted, setTimerCompleted ] = useState(false);
    const [ minutes, setMinutes ] = useState(2);
    const [ seconds, setSeconds ] = useState(0);
    const [ confirmDisable, setConfirmDisable ] = useState(false)
    const [ invalidOtp, setInvalidOtp ] = useState(false);
    const {ErrorToast, SuccessToast} = useToast();
    const history = useHistory();
    const [ isApiLoading, setIsApiLoading ] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            if (minutes === 0 && seconds === 0) {
                clearInterval(timer);
                setTimerCompleted(true);
            } else if (seconds === 0) {
                setMinutes((prevMinutes) => prevMinutes - 1);
                setSeconds(59);
            } else {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [ minutes, seconds ]);


    function VerifyOtp() {
        const emailId = localStorage.getItem("resetPassword_emailId")
        try {
            setConfirmDisable(true);
            Http.post(`/email/${emailId}/verifyOtp`, {otp}).subscribe((response: any) => {
                if (response?.status === 200) {
                    SuccessToast(response?.message)
                    localStorage.setItem('resetPassword_token', response?.token)
                    history.push("/forgotPassword/resetPassword")
                    setConfirmDisable(false);
                } else {
                    setInvalidOtp(true)
                    setConfirmDisable(false);
                    ErrorToast(response?.message)
                }
            },
                error => {
                    setInvalidOtp(true);
                    setConfirmDisable(false);
                    if (error?.message !== "Invalid OTP") {
                        ErrorToast(error?.message || "Something unexpected happened, try again later!")
                    }
                }
            )
        } catch (err: any) {
            setConfirmDisable(false);
            ErrorToast(err.message || "Something unexpected happened, try again later!")
        }
    }

    function resendOtp() {
        const emailId = localStorage.getItem('resetPassword_emailId')
        if (emailId !== "") {
            try {
                setIsApiLoading(true)
                Http.get(`/email/${emailId}/dispatchOtp`).subscribe(
                    (response: any) => {
                        if (response.status === 200) {
                            SuccessToast(response.message)
                            history.push('/forgotPassword/otpVerification')
                            setIsApiLoading(false);
                            setTimerCompleted(false);
                            setMinutes(2)
                            setSeconds(0)
                        }
                    },
                    err => {
                        setIsApiLoading(false);
                        ErrorToast(err?.message)
                    })
            } catch (e: any) {
                setIsApiLoading(false);
                ErrorToast(e?.message)
            }
        } else {
            ErrorToast("Please enter valid email id.")
        }
    }

    const handleCancel = () => {
        history.push('/forgotPassword')
        localStorage.removeItem('resetPassword_emailId')
        localStorage.removeItem('resetPassword_token')
    }

    return (
        <div className='otpVerification w-full' >
            <div className='title' >Enter verification code</div>
            <div className='subTitle' >We’ve sent a code to your email</div>
            <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                separator={<span> </span>}
                inputStyle='otp-input'
                containerStyle={{justifyContent: "space-between", marginTop: "45px", width: "369px"}}
            />
            {invalidOtp && <div className="flex items-center justify-center mt-1" style={{width: "369px", color: "#E40303"}} >
                <div className='flex items-center justify-start' style={{fontWeight: 400, fontSize: "12px", width: "100%"}} >Please enter valid OTP</div>
            </div>}
            <div style={{width: "369px", justifyContent: timerCompleted ? "center" : "space-between"}} className='mt-2 flex items-center justify-between'>
                <div className={`${otp.length < 6 ? "resend-otp" : "resend-otp-entered"} `} style={{
                    color: timerCompleted ? "#3461A2" : "#9299B4",
                    textAlign: timerCompleted ? "center" : "left",
                    cursor: (timerCompleted && !isApiLoading) ? "pointer" : ""
                }}
                    onClick={() => {if (timerCompleted && !isApiLoading) {resendOtp()} }}
                >Resend OTP</div>
                {!timerCompleted && <div className='otp-time' >{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</div>}
            </div>
            <div style={{width: "369px", marginTop: "25px"}} className='flex items-center justify-between'>
                <button
                    onClick={() => {VerifyOtp()}}
                    className='verify-cancel-btn'
                    style={{
                        background: (otp.length < 6 || confirmDisable) ? "#cccccc" : "rgba(250, 116, 18, 1)",
                        cursor: (otp.length < 6 || confirmDisable) ? "not-allowed" : "pointer"
                    }}
                    disabled={(confirmDisable || otp.length < 6)} >Submit</button>
                <button className='verify-cancel-btn' style={{color: "rgba(116, 118, 123, 1)", background: "rgba(240, 240, 240, 1)"}} onClick={handleCancel}>Cancel</button>
            </div>
        </div>
    )
}

export default OtpVerification;